import { gql, useQuery } from "@apollo/client";
import React from "react";
import "./Dashboard.scss";
import { Loading, LoadTable } from "../../Components";
import RefreshIcon from "./RefreshIcon";

const trackShipmentsByAccountQuery = gql`
  query Query {
    getTrackShipmentAnalysisByAccount
  }
`;

const TrackShipmentByAccount = () => {
  const Key = "Track_Shipment_By_Account";
  function formatShipmentData(data) {
    console.log(data);
    return data?.getTrackShipmentAnalysisByAccount.map((entry) => ({
      _id: entry._id,
      Proprietor_Name: entry.accountDetails.Proprietor_Name,
      Business_Name: entry.accountDetails.Business_Name,
      LiveShipments: entry.liveShipments,
      TodayShipments: entry.todayShipments,
      TotalShipments: entry.totalShipments,
    }));
  }
  const colAddition = ["LiveShipments", "TodayShipments", "TotalShipments"];
  const { data, loading, error, refetch, networkStatus } = useQuery(trackShipmentsByAccountQuery, {
    context: { headers: { "X-GraphQL-Server": "secondary" } },
    notifyOnNetworkStatusChange: true,
  });
  const updateData = data?.getTrackShipmentAnalysisByAccount && formatShipmentData(data);
  console.log(updateData);
  if (loading) {

    return  <Loading />
  }
  if (error) {
    return <p>Error: {error.message}</p>;
  }
  return (
    <>
      <div className="title_With_Loading_Logo">
        <div className="load-post-title">Load Post By Erp User</div>
        <div className="load-post-logo">
          <RefreshIcon handleRefetch={refetch} loading={loading} />
        </div>
      </div>
      <div className="Account_Track_Shipments_Box">
        <LoadTable
          data={updateData}
          loading={loading}
          error={error}
          title={Key}
          settings={false}
          options={false}
          colAddition={colAddition}
        />
      </div>
    </>
  );
};

export default TrackShipmentByAccount;
